import styled from 'styled-components';

export const TooltipTriggerWrapper = styled.span`
  display: inline-block;
`;

export const TooltipTriggerText = styled.span`
  color: ${({ theme }) => theme.color.blue[700]};
  cursor: pointer;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;
